module.exports = __webpack_public_path__ + "static/media/frames-21.8bf8c772.jpg";